import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';
import { emitter } from 'shared/helpers/mitt';

// ConversationCard (clique na lista) e MessagesView (montagem do chat) podem
// disparar markMessagesRead para a mesma conversa quase simultaneamente. Sem
// esse guard, os dois deltas otimistas de -1 se somam e o contador da caixa
// (ex.: Pessoais) zera antes do fetch real corrigir o valor. O mesmo guard é
// reaplicado a markMessagesUnread por simetria (menu de contexto/bulk action
// disparando duas vezes para a mesma conversa).
const pendingReadConversationIds = new Set();
const pendingUnreadConversationIds = new Set();

export default {
  markMessagesRead: async ({ commit, rootGetters = {} }, data) => {
    const conversationId = data?.id;
    if (pendingReadConversationIds.has(conversationId)) return;
    pendingReadConversationIds.add(conversationId);

    try {
      const getConversationById = rootGetters.getConversationById;
      const previousConversation =
        typeof getConversationById === 'function'
          ? getConversationById(conversationId)
          : null;
      const previousUnreadCount = Number(
        previousConversation?.unread_count || 0
      );
      // Otimista: zera o badge no clique em vez de esperar a ida-e-volta da
      // API, que é o atraso percebido pelo usuário ao abrir a conversa.
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id: conversationId,
        lastSeen: Math.floor(Date.now() / 1000),
        unreadCount: 0,
      });
      emitter.emit('conversation_unread_state_changed', {
        id: conversationId,
        previousUnreadCount,
        unreadCount: 0,
      });
      emitter.emit('fetch_conversation_stats', {
        immediate: true,
        force: true,
      });

      const {
        data: {
          id,
          agent_last_seen_at: lastSeen,
          unread_count: unreadCount = 0,
        },
      } = await ConversationApi.markMessageRead(data);
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
      if (unreadCount !== 0) {
        // Corrige o badge caso o servidor discorde do otimista (ex.: nova
        // mensagem chegou entre o clique e a resposta da API).
        emitter.emit('conversation_unread_state_changed', {
          id,
          previousUnreadCount: 0,
          unreadCount,
        });
        emitter.emit('fetch_conversation_stats', {
          immediate: true,
          force: true,
        });
      }
    } catch (error) {
      // Handle error
    } finally {
      pendingReadConversationIds.delete(conversationId);
    }
  },

  markMessagesUnread: async ({ commit, rootGetters = {} }, { id }) => {
    if (pendingUnreadConversationIds.has(id)) return;
    pendingUnreadConversationIds.add(id);

    try {
      const getConversationById = rootGetters.getConversationById;
      const previousConversation =
        typeof getConversationById === 'function'
          ? getConversationById(id)
          : null;
      const previousUnreadCount = Number(
        previousConversation?.unread_count || 0
      );
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
      emitter.emit('conversation_unread_state_changed', {
        id,
        previousUnreadCount,
        unreadCount,
      });
      emitter.emit('fetch_conversation_stats', {
        immediate: true,
        force: true,
      });
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      pendingUnreadConversationIds.delete(id);
    }
  },
};
